import { ispApi } from 'src/api';
import { AxiosRequestConfig } from 'axios';

import { TanstackTableSearchParamsAdapter } from '@itm/shared-frontend/lib/utils';

import {
  CompanyResponse,
  CompanyConfigResponse,
  CompanyConfigurationsWithCount,
  UpdateCompanyConfigurationDto,
  UpdateCompanyMatchEngineConfigModel,
  TriggerCompanyIdsModel,
  ClientConfigurationResyncResponse,
} from 'src/types';

export const getCompanyListAll = (config: AxiosRequestConfig = {}) =>
  ispApi.get<CompanyResponse[]>('/isp-internal/api/v1/companies/all', config);

export const getCompanyById = (companyId: string, config: AxiosRequestConfig = {}) =>
  ispApi.get<CompanyConfigResponse>(`/isp-internal/api/v1/companies/${companyId}`, config);

export const getCompanyConfigurationListSearch = (
  params: TanstackTableSearchParamsAdapter,
  config: AxiosRequestConfig = {},
) => ispApi.get<CompanyConfigurationsWithCount>('/isp-internal/api/v1/companies/configurations', { ...config, params });

export const updateCompanyConfiguration = (data: UpdateCompanyConfigurationDto) =>
  ispApi.patch<void>('/isp-internal/api/v1/companies/configurations', data);

export const checkCompanyPdpPublishCredentials = (companyId: string, config: AxiosRequestConfig = {}) =>
  ispApi.get<void>(`/isp-internal/api/v1/companies/${companyId}/pdp/check`, config);

export const enableCompanyPDPPublish = (companyId: string) =>
  ispApi.patch<void>(`/isp-internal/api/v1/companies/${companyId}/pdp`);
export const disableCompanyPDPPublish = (companyId: string) =>
  ispApi.delete<void>(`/isp-internal/api/v1/companies/${companyId}/pdp`);

export const updateCompanyEngineConfiguration = (companyId: string, data: UpdateCompanyMatchEngineConfigModel) =>
  ispApi.patch<void>(`/isp-internal/api/v1/companies/${companyId}/update-company-match-engine-config`, data);

export const getChangesExtractIsEnabled = (companyId: string, config: AxiosRequestConfig = {}) =>
  ispApi.get<boolean>(`/isp-internal/api/v1/companies/${companyId}/changes-extract`, config);
export const enableChangesExtract = (companyId: string) =>
  ispApi.patch<void>(`/isp-internal/api/v1/companies/${companyId}/changes-extract`);
export const disableChangesExtract = (companyId: string) =>
  ispApi.delete<void>(`/isp-internal/api/v1/companies/${companyId}/changes-extract`);

export const triggerClientConfigurationResync = (data: TriggerCompanyIdsModel) =>
  ispApi.post<ClientConfigurationResyncResponse>(
    '/isp-internal/api/v1/companies/trigger-update-client-configuration',
    data,
  );

export const enableCompanyPgpEncryption = (companyId: string) =>
  ispApi.patch<void>(`/isp-internal/api/v1/companies/${companyId}/pgp-encryption`);
export const disableCompanyPgpEncryption = (companyId: string) =>
  ispApi.delete<void>(`/isp-internal/api/v1/companies/${companyId}/pgp-encryption`);
